<template>
  <div class="container">
    <img :src="success" class="success" />
    <div class="tip">您已报名成功此课程</div>
    <div class="activation">
      请点击下方按钮 <br />
      添加老师激活课程
    </div>
    <img :src="arrow" class="arrow" />
    <div class="add" @click="goWeixin">点击打开微信</div>

    <div class="send">上课时间、听课方式等由班主任发送给您</div>
  </div>
</template>

<script>
export default {
  name: 'H5OpenMini',
  components: {},
  props: {},
  data() {
    return {
      success: require('@/assets/success1.png'),
      arrow: require('@/assets/arrow.png'),
      timer: null,

      url: '',
      id: '',
      userId: '',
      count: 0
    }
  },
  created() {
    sessionStorage.setItem('isJump', true)
    this.id = this.$route.query.id
    this.getOrderData()
  },

  destroyed() {
    clearTimeout(this.timer)
    this.timer = null
  },
  methods: {
    async getOrderData() {
      const res = await this.$http.get('/app/channels/getOrder', {
        id: this.id
      })
      this.userId = res.data.userId
      this.getMaScheme()
    },
    async getMaScheme() {
      if (!this.userId) return
      const res = await this.$http.get('/app/channels/getMaScheme', {
        userId: this.userId
      })

      this.url = res.data
      if(!this.url&&this.count<3){
        this.getMaScheme();
        this.count++;
        return
      }
      this.timer = setTimeout(() => {
        this.goWeixin()
      }, 1000)
    },
    goWeixin() {
      // window.location.href = 'weixin://dl/business/?appid=wx2fa3691b1bc69740&path=pages/index/index&env_version=release'
      window.location.href = this.url || 'weixin://dl/business/?t=f4S6BOwGMtf'
    }
  }
}
</script>

<style scoped lang="less">
.container {
  font-size: 28px;
  color: #333;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
  height: 100vh;

  .content {
    padding: 32px;
    margin-top: -90px;
    position: relative;
  }
  .success {
    width: 200px;
    height: 200px;
    margin-bottom: 16px;
    margin-top: 100px;
    margin-bottom: 10px;
  }
  .tip {
    font-size: 32px;
    color: #666;
  }

  .send {
    font-size: 24px;
    color: #999;
  }
  .answering {
    width: 620px;
    height: 220px;
  }
  .activation {
    font-size: 56px;
    font-weight: 700;
    padding: 100px 0 40px;
    text-align: center;
    line-height: 84px;
    color: #000;
  }
  .arrow {
    width: 140px;
    height: 40px;
    margin-bottom: 40px;
    -webkit-animation: fadearrow 1s ease infinite;
    animation: fadearrow 1s ease infinite;
  }
  .add {
    width: 622px;
    height: 80px;
    background: #00c8c8;
    border-radius: 50px;
    display: block;
    line-height: 80px;
    text-align: center;
    font-size: 32px;
    color: #fff;
    font-weight: 700;
    outline: none;
    margin-bottom: 20px;
    -webkit-animation: fadenum 1s ease infinite;
    animation: fadenum 1s ease infinite;
  }
}
@keyframes fadenum {
  0% {
    transform: scale(1.05);
    -webkit-transform: scale(1.05);
  }
  50% {
    transform: scale(1);
    -webkit-transform: scale(1);
  }
  100% {
    transform: scale(1.05);
    -webkit-transform: scale(1.05);
  }
}
@keyframes fadearrow {
  0% {
    transform: translateY(30%);
    -webkit-transform: translateY(30%);
  }
  50% {
    transform: translateY(0);
    -webkit-transform: translateY(0);
  }
  100% {
    transform: translateY(30%);
    -webkit-transform: translateY(30%);
  }
}
</style>
